// extracted by mini-css-extract-plugin
module.exports = {"select-button":"select-button"};